import React from "react";
import { useFeatureFlagEnabled } from "posthog-js/react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import AppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import MenuItem from "./MenuItem";
import { useDrawer } from "contexts/DrawerContext";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { logout } from "store/features/authSlice";

import { ReactComponent as IbanLogo } from "assets/images/iban_oplata-logo.svg";
import { ReactComponent as BurgerIcon } from "assets/images/burger-icon.svg";

import { menuItems } from "./variables";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { Drawer, styles } from "./styles";

interface MobileMenuProps {}

const MobileMenu: React.FC<MobileMenuProps> = () => {
  const { open, openDrawer, closeDrawer } = useDrawer();

  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.loading.isLoading);

  const onLogout = async () => {
    analytics().sendEvent(AnalyticsEvents.logout);
    await dispatch(logout()).unwrap();
  };

  return (
    <>
      <AppBar position="sticky" sx={styles.appBar}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <IbanLogo />
          <Typography variant="body1" sx={{ ml: 1.5 }}>
            IBAN oplata
          </Typography>
          <IconButton
            sx={{ ml: "auto", p: 0 }}
            onClick={openDrawer}
            aria-label="mobile-menu"
          >
            <BurgerIcon />
          </IconButton>
        </Box>
      </AppBar>
      <Drawer open={open} onClose={closeDrawer} anchor="right">
        <Box role="presentation" onClick={closeDrawer}>
          <Box sx={{ pl: 2, py: 5 }}>
            <IbanLogo />
          </Box>
          <List sx={{ my: 0, mx: 2, p: 0 }}>
            {menuItems.map((group, index) => {
              const isLast = menuItems.length - 1 === index;

              return (
                <Box key={`group-${index}`}>
                  {group.map((item) => {
                    // TODO: remove after feature release
                    const showItem = item.featureFlag
                      ? useFeatureFlagEnabled(item.featureFlag)
                      : true;

                    return (
                      showItem && (
                        <MenuItem
                          item={item}
                          key={item.route}
                          onClose={closeDrawer}
                          onClick={
                            item.route === "logout" ? onLogout : undefined
                          }
                          loading={item.route === "logout" && loading}
                        />
                      )
                    );
                  })}
                  {!isLast && <Divider sx={{ my: 2 }} />}
                </Box>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileMenu;
